const { registerBlockType } = wp.blocks;

import attributes from './attributes';
import Edit from './edit';
import Save from './save';

registerBlockType('app/locate-selector', {
  title: 'Seletor de cidade',
  description: 'Lista completa de cidades com busca',
  icon: 'location-alt',
  category: 'design',
  parent: ['app/locations'],
  attributes,

  edit: (props) => <Edit {...props} />,
  save: (props) => <Save {...props} />,
});
